import { useEffect, useState } from "react";

// Should be kept in sync with $bp-md in _breakpoints.scss
export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

const doesMediaQueryMatch = (mediaQuery: string) => {
  return typeof window !== "undefined" &&
    typeof window.matchMedia === "function"
    ? window.matchMedia(mediaQuery).matches
    : false;
};

export const useMediaQuery = (mediaQuery: string) => {
  const [mediaQueryMatches, setMediaQueryMatches] = useState(() =>
    doesMediaQueryMatch(mediaQuery),
  );

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;

    const mediaQueryList = window.matchMedia(mediaQuery);

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setMediaQueryMatches(event.matches);
    };

    // Re-sync in case the viewport changed between render and effect
    setMediaQueryMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", handleMediaQueryChange);

    return () => {
      mediaQueryList.removeEventListener("change", handleMediaQueryChange);
    };
  }, [mediaQuery]);

  return mediaQueryMatches;
};
